import { gql } from '@apollo/client';

/**
 * order_wms 可订正列白名单（与后端 OrderWmsFixableColumn 枚举一一对应）。
 * 新增列时后端枚举与此处、下拉 label 三处需同步。
 */
export const ORDER_WMS_FIXABLE_COLUMNS = [
  { value: 'TT_BIZ_TYPE', label: 'tt_biz_type（TT业务类型，仅 CBT/FBT）', column: 'tt_biz_type' },
  { value: 'EXT_SORT_CODE', label: 'ext_sort_code（分拣码）', column: 'ext_sort_code' },
  { value: 'EXT_SHIP_TO_SITE', label: 'ext_ship_to_site（目的站点）', column: 'ext_ship_to_site' },
  { value: 'EXT_SHIP_VIA_SITE', label: 'ext_ship_via_site（中转站点）', column: 'ext_ship_via_site' },
  { value: 'TEMU_SORTING_CODE', label: 'temu_sorting_code（Temu 分拣码）', column: 'temu_sorting_code' },
  { value: 'SORTING_RULE_FIRST', label: 'sorting_rule_first（第一分拣规则）', column: 'sorting_rule_first' },
  { value: 'SORTING_RULE_SECOND', label: 'sorting_rule_second（第二分拣规则/预分拣码）', column: 'sorting_rule_second' },
  { value: 'LINEHAUL_CODE', label: 'linehaul_code（卡转商代码）', column: 'linehaul_code' },
] as const;

export type OrderWmsFixableColumnValue = (typeof ORDER_WMS_FIXABLE_COLUMNS)[number]['value'];

/** 仅 tt_biz_type 列限定取值，其余列为自由字符串 */
export const TT_BIZ_TYPE_ALLOWED_VALUES = ['CBT', 'FBT'] as const;

export interface OrderWmsColumnFixItemInput {
  orderId: number;
  value: string;
}

export interface FixOrderWmsColumnVariables {
  column: OrderWmsFixableColumnValue;
  items: OrderWmsColumnFixItemInput[];
  onlyWhenNull: boolean;
  dryRun: boolean;
}

export interface FixOrderWmsColumnResponse {
  fixOrderWmsColumn: {
    requestedCount: number;
    fixableCount: number;
    updatedCount: number;
    notMatchedOrderIds: number[];
    failedOrderIds: number[];
  };
}

export const FIX_ORDER_WMS_COLUMN = gql`
  mutation FixOrderWmsColumn(
    $column: OrderWmsFixableColumn!
    $items: [OrderWmsColumnFixItemInput!]!
    $onlyWhenNull: Boolean!
    $dryRun: Boolean!
  ) {
    fixOrderWmsColumn(column: $column, items: $items, onlyWhenNull: $onlyWhenNull, dryRun: $dryRun) {
      requestedCount
      fixableCount
      updatedCount
      notMatchedOrderIds
      failedOrderIds
    }
  }
`;
